import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { venuesQueryOptions } from '@/features/venues/api'
import { isLegacyVenueSearch, parseVenueSearch } from '@/features/venues/model/venue-panels'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/venues')({
  validateSearch: parseVenueSearch,
  beforeLoad: ({ location, search }) => {
    if (isLegacyVenueSearch(location.search)) {
      throw redirect({
        href: `${location.pathname}${search.panel ? `?panel=${search.panel}` : ''}`,
        replace: true,
      })
    }
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(venuesQueryOptions(params.workspaceSlug)),
  component: Outlet,
})
